import React, {useEffect, useRef, useState} from 'react';
import {connect, DispatchProp} from "react-redux";
import {useTranslation} from "react-i18next";
import {getStoreState} from "../../services/Store/reducer";
import {RootState} from "../../../reducers";
import {ConfigApi} from "../../services/Api/types";
import {useNavigate, useParams} from "react-router-dom";
import LoadingContainer from "../../components/Common/LoadingContainer";
import {Navbar} from "react-bootstrap";
import AppConfig from "../../services/AppConfig";
import {ReactComponent as LeftIco} from "../../../images/icons/arrow-left.svg";
import {usePrefix} from "../../services/Prefix";

interface OwnProps {
    config: ConfigApi
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;
const TableOrderPage = (props: Props) => {
    const {t} = useTranslation();
    const [loading, setLoading] = useState(true);
    const prefix = usePrefix();
    const {orderUrl} = useParams();
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const navigate = useNavigate();
    const [canGoBack, setCanGoBack] = useState(true);
    const defaultLink = AppConfig.getLinkWithPrefix("/", prefix);

    useEffect(() => {
        const onMessage = (event: MessageEvent) => {
            if (event.data && typeof event.data === "object" && "can_go_back" in event.data) {
                const canGoBack = event.data.can_go_back;
                setCanGoBack(canGoBack);
            } else {
                setCanGoBack(true)
            }

            if (event?.data?.type === "IFRAME_READY") {
                setLoading(false);
                handlePaymentRedirectMessage();
            }
        };

        window.addEventListener("message", onMessage);
        return () => window.removeEventListener("message", onMessage);
    }, []);

    const handleGoBack = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.currentTarget.blur()
        if (canGoBack) {
            navigate(defaultLink);
        } else {
            if (iframeRef.current?.contentWindow) {
                const payload = {navigate_inside_iframe: true}
                iframeRef.current.contentWindow.postMessage(payload, "*");
            }
        }
    };

    if (!orderUrl) return (
        <>
            Nie znaleziono
        </>
    )

    const tableOrderUrlBase = decodeURIComponent(escape(atob(orderUrl)));

    const handlePaymentRedirectMessage = () => {
        try {
            const url = (window?.location?.origin || "") + `${window.location.pathname.replace(`${orderUrl}`, "")}`;
            const payload = {parent_redirect_url: url};

            if (iframeRef.current?.contentWindow) {
                iframeRef.current.contentWindow.postMessage(payload, "*");
            }
        } catch (e) {
            return null
        }
    }

    return (
        <div className="table-order-page">
            <Navbar className={"sticky-top navbar-back mb-0 table-order-page-navbar-back"} style={{
                height: "60px",
            }}>
                <div className={"navbar-brand-container"}>
                    <button className={"btn btn-back"} onClick={handleGoBack}>
                        <LeftIco/> {t("common.action.back")}
                    </button>
                </div>
            </Navbar>
            {loading && (
                <LoadingContainer/>
            )}
            <iframe
                ref={iframeRef}
                src={tableOrderUrlBase}
                style={{
                    display: 'block',
                    width: '100%',
                    height: 'calc(100dvh - 60px)',
                }}
                allow="payment"
                sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation"
                title="Embedded content"
            />
        </div>
    )
}

const mapStateToProps = (state: RootState) => ({
    store_state: getStoreState(state.config)
})

const connector = connect(mapStateToProps);

export default connector(TableOrderPage);